import { render, staticRenderFns } from "./comRemindView.vue?vue&type=template&id=b764ada2&scoped=true&"
import script from "./comRemindView.vue?vue&type=script&lang=js&"
export * from "./comRemindView.vue?vue&type=script&lang=js&"
import style0 from "./comRemindView.vue?vue&type=style&index=0&id=b764ada2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b764ada2",
  null
  
)

export default component.exports